import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";
const path = "/management/workspace";
export const managementWorkspace = createCrudVuexModule({
  moduleName: "managementWorkspace",
  path,

  namespaced: true,
  state: {
    showInviteModal: false,
    paginationMember: undefined,
    pagination: undefined,
    workspaces: [],
    organizations: [],
    members: [],
    isLoading: false,
    isUpdating: false,
    memberInfo: undefined,
    isMemberInfoLoading: false,
    editedEntity: undefined,
    paginateWorkspaceOrganization: undefined,
  },
  getters: {
    workspaces: (state) => state.workspaces,
    organizations: (state) => state.organizations,
    members: (state) => state.members,
    pagination: (state) => state.pagination,
    paginationMember: (state) => state.paginationMember,
    showInviteModal: (state) => state.showInviteModal,
    paginateWorkspaceOrganization: (state) => state.paginateWorkspaceOrganization,

    roleByMemberId: (state) => (id) => {
      return state.paginationMember?.docs.filter((member) => member._id === id)[0].workspaceRole;
    },
    isLoading: (state) => state.isLoading,
    isUpdating: (state) => state.isUpdating,
    memberInfo: (state) => state.memberInfo,
    isMemberInfoLoading: (state) => state.isMemberInfoLoading,
    editedEntity: (state) => state.editedEntity ?? {},
  },

  mutations: {
    paginateWorkspaceOrganization: (state, value) => (state.paginateWorkspaceOrganization = value),
    memberRole: (state, { member, role }) => {
      const memberIndex = state.paginationMember.docs.findIndex((item) => item._id === member._id);
      if (memberIndex !== -1) {
        const updatedMember = Object.assign({}, state.paginationMember.docs[memberIndex]);
        updatedMember.workspaceRole = role;
        state.paginationMember.docs.splice(memberIndex, 1, updatedMember);
        return updatedMember.workspaceRole;
      }
    },
    memberEdited: (state, { member, edited }) => {
      const memberIndex = state.paginationMember.docs.findIndex((item) => item._id === member._id);
      if (memberIndex !== -1) {
        const updatedMember = Object.assign({}, state.paginationMember.docs[memberIndex]);
        updatedMember.edited = edited;
        state.paginationMember.docs.splice(memberIndex, 1, updatedMember);
      }
    },

    workspaces: (state, value) => (state.workspaces = value),
    organizations: (state, value) => (state.organizations = value),
    members: (state, value) => (state.members = value),
    isLoading: (state, value) => (state.isLoading = value),
    isUpdating: (state, value) => (state.isUpdating = value),
    memberInfo: (state, value) => (state.memberInfo = value),
    isMemberInfoLoading: (state, value) => (state.isMemberInfoLoading = value),
    editedEntity: (state, value) => (state.editedEntity = value),
    paginationMember: (state, value) => (state.paginationMember = value),
    pagination: (state, value) => (state.pagination = value),
    showInviteModal: (state, value) => (state.showInviteModal = value),
  },

  actions: {
    async create({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post(`${path}`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async update({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);

        const response = await rest.put(`${path}`, payload);

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async save({ dispatch }, payload) {
      if (payload.workspace._id) {
        return dispatch("update", payload);
      } else {
        return dispatch("create", payload);
      }
    },

    // TKP-83 — sistem sözlüğüyle tohumlama (yalnız YEREL ve sözlüğü boş çalışma alanında; kuralı backend uygular).
    async librarySeedStatus(_, workspaceId) {
      return rest.post(`${path}/library/seed/status`, { workspace: workspaceId });
    },
    async seedLibrary({ commit }, workspaceId) {
      commit("isUpdating", true);
      try {
        return await rest.post(`${path}/library/seed`, { workspace: workspaceId });
      } finally {
        commit("isUpdating", false);
      }
    },

    // TKP-171 / md.34 — kopyala ve kapat: sistem sözlüğü kopyalanır, organizasyon referansları eşlenir, kip YEREL olur.
    async localizeLibrary({ commit }, { workspaceId, dryRun = false }) {
      commit("isUpdating", true);
      try {
        return await rest.post(`${path}/library/localize`, { workspace: workspaceId, dryRun });
      } finally {
        commit("isUpdating", false);
      }
    },

    // TKP-205 — organizasyon kayıtlarında sistem sözlük kalemine bağlı kalan referanslar: rapor + onarım (YEREL çalışma alanı)
    async librarySystemRefs(_, workspaceId) {
      return rest.post(`${path}/library/system-refs`, { workspace: workspaceId });
    },
    async repairLibrarySystemRefs({ commit }, { workspaceId, dryRun = false }) {
      commit("isUpdating", true);
      try {
        return await rest.post(`${path}/library/system-refs/repair`, { workspace: workspaceId, dryRun });
      } finally {
        commit("isUpdating", false);
      }
    },

    async duplicate({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post(`${path}/duplicate`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async delete({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post(`${path}/delete`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async updateName({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.put(`${path}`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async fetchWorkspaceDetail({ commit }, id) {
      commit("isLoading", true);
      try {
        const response = await rest.get(`${path}/${id}`);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },

    async fetchWorkspaceOrganizations({ commit }, { id, request }) {
      commit("isLoading", true);
      try {
        const response = await rest.post(`${path}/${id}/organizations`, { workspaceId: id, pagination: request });

        commit("paginateWorkspaceOrganization", response.data);

        return response;
      } finally {
        commit("isLoading", false);
      }
    },

    async fetchWorkspaceMemberInfo({ commit }, id) {
      commit("isMemberInfoLoading", true);
      try {
        const response = await rest.get(`${path}/member/${id}`);

        commit("memberInfo", response.data);

        return response;
      } finally {
        commit("isMemberInfoLoading", false);
      }
    },

    async setMemberOrganizationAcl({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.put(`${path}/member-acl/set`, payload);

        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async invite({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post(`${path}/invite`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async updateMemberWorkspaceRole({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.put(`${path}/member`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async removeMember({ commit }, { memberId, ownerId }) {
      commit("isUpdating", true);
      try {
        const response = await rest.delete(`${path}/member/${memberId}`, { headers: { "owner-id": ownerId } });
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async paginateMember({ commit, state }, { pagination, id }) {
      commit("isLoading", true);
      try {
        const response = await rest.post(`${path}/${id}/members/paginate`, { pagination });
        commit("paginationMember", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },

    async paginate({ commit }, pagination = {}, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("pagination", undefined);
        }

        const response = await rest.post(`${path}/paginate`, { pagination });
        commit("pagination", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
    async workspaces({ commit }, pagination = {}, clearStateBeforeRest = false) {
      commit("isLoading", true);
      try {
        if (clearStateBeforeRest) {
          commit("workspaces", undefined);
        }

        const response = await rest.post(`${path}/paginate`, { pagination });
        commit("workspaces", response.data);
        return response;
      } finally {
        commit("isLoading", false);
      }
    },
  },
});
